module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/4-5mill-inactive-ffc5ce609893c2bb9d4f692c53b514c0.png";